import { render, staticRenderFns } from "./PoiDetail.vue?vue&type=template&id=9ae26aaa&scoped=true&"
import script from "./PoiDetail.vue?vue&type=script&lang=js&"
export * from "./PoiDetail.vue?vue&type=script&lang=js&"
import style0 from "./PoiDetail.vue?vue&type=style&index=0&id=9ae26aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae26aaa",
  null
  
)

export default component.exports